import type { AssignmentTemplatesStore } from './interfaces'

export const actions = {
  setLoading (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['loading']): void {
    this.loading = payload
  },
  setTemplatesPaginatedData (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['templatesPaginatedData']): void {
    this.templatesPaginatedData = payload
  },
  setFilterSearch (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterType (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['filterType']): void {
    this.filterType = payload
  },
  setFilterDisciplineCode (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['filterDisciplineCode']): void {
    this.filterDisciplineCode = payload
  },
  setFilterGrade (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['filterGrade']): void {
    this.filterGrade = payload
  },
  setFilterModuleId (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['filterModuleId']): void {
    this.filterModuleId = payload
  },
  setCurrentPage (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['perPage']): void {
    this.perPage = payload
  },
  setModalCreate (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['isModalCreate']): void {
    this.isModalCreate = payload
  },
  setTemplateToDelete (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['templateToDelete']): void {
    this.templateToDelete = payload
  },
  setTemplateToDuplicate (this: AssignmentTemplatesStore, payload: AssignmentTemplatesStore['templateToDuplicate']): void {
    this.templateToDuplicate = payload
  },
  /** Also returns to page 1: the old page may not exist in the new result set. */
  resetFilters (this: AssignmentTemplatesStore): void {
    this.filterSearch = null
    this.filterType = null
    this.filterDisciplineCode = null
    this.filterGrade = null
    this.filterModuleId = null
    this.currentPage = 1
  },
}
